
const TicketResponse = {
	// "version": "1.0.0.0",
	// "statusCode": 200,
	// "message": "OK",
	// "responseException": null,
	// "result": {}
		"gdsRefrenceID": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
		"uniqueId": "string",
		"bookedBy": "string",
		"orderBy": "string",
		"clientBalance": 0,
		"tktTimeLimit": "string",
		"category": 0,
		"travelItinerary": {
			"itineraryInfo": {
				"customerInfoes": [
					{
						"customer": {
							"passengerType": 0,
							"passportNumber": "string",
							"nationalId": "string",
							"dateOfBirth": "string",
							"passportExpireDate": "string",
							"paxName": {
								"passengerFirstName": "string",
								"passengerMiddleName": "string",
								"passengerLastName": "string",
								"passengerTitle": 0
							}
						},
						"eTicketNumber": "string",
						"dateOfIssueEticket": "string",
						"eTicketPDF": [
							"string"
						]
					}
				],
				"reservationItems": [
					{
						"arrivalRailStationId": "string",
						"arrivalDateTime": "string",
						"departureRailStationId": "string",
						"departureDateTime": "string",
						"code": "string",
						"journeyDuration": "string",
						"journeyDurationPerMinute": 0,
						"vendingOperatorCode": "string",
						"operatorCode": "string",
						"resBookDesigCode": "string",
						"stopQuantity": 0,
						"baggage": "string",
						"class": "string"
					}
				],
				"netRate": 0,
				"currency": "string"
			},
			"bookingNotes": [
				{
					"note": "string",
					"date": "string"
				}
			],
			"services": [
				{
					"passengerFirstName": "string",
					"passengerMiddleName": "string",
					"passengerLastName": "string",
					"description": "string",
					"serviceId": "string",
					"behavior": 0,
					"serviceCost": {
						"amount": 0,
						"currency": "string"
					}
				}
			]
		},
		"statusCode": 100
};
 

  export default TicketResponse;
  